import { Box, Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import AdminDataGrid from 'csam/admin/components/AdminDataGrid';
import AdminPageHeader from 'csam/admin/components/AdminHeader';
import AdminPageLoader from 'csam/admin/components/AdminPageLoader';
import AdminWrapper from 'csam/admin/components/AdminWrapper';
import AdminInternalError from 'csam/admin/pages/AdminInternalError';
import { useAuthenticatedQuery } from 'csam/api/api';
import LocaleContext from 'csam/components/LocaleContext';
import { fixed } from 'csam/utils/Constants';
import { useContext, useState } from 'react';
import { CSVLink } from 'react-csv';


const AllPagesLandingActivity = () => {
    const { locale, setLocale } = useContext(LocaleContext);
    const [_selectedIds, setSelectedIds] = useState<string[]>([]);

    const headers = [
        { label: 'Id', key: 'id' },
        { label: 'User Id', key: 'user_id' },
        { label: 'Email', key: 'email' },
        { label: 'Page Name', key: 'page_name' },
        { label: 'Created At (IST)', key: 'created_at' },
    ];

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Id', filterable: false, width: 80, renderCell: (params) => params.value },
        {
            field: 'user_id',
            headerName: 'User ID',
            width: 100,
            renderCell: (params) => (params.row.user_id ? params.row.user_id.user_id : 'N/A'),
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 350,
            renderCell: (params) => (params.row.user ? params.row.user.email : 'N/A'),
        },
        { field: 'page_name', headerName: 'Page Name', width: 300 },
        { field: 'created_at', headerName: 'Created At', width: 300 },
    ];
    interface UserLandingActivty {
        id: number;
        user_id: number;
        user?: {
            email: string;
        };
        created_at: string;
        page_name: string;
        status: number;
    }
    interface UserLandingActivtyResponse {
        success: boolean;
        data: UserLandingActivty;
        translatableFields: string[];
    }
    const relations = ['user'];
    const relationsParam = relations.join(',');
    const localeFromStorage = localStorage.getItem('locale') || 'en';
    const { isPending, error, data } = useAuthenticatedQuery<UserLandingActivtyResponse[]>(
        ['UserLandingPage', 'UserLandingPageData', locale],
        {
            url: `${fixed}admin/${locale || localeFromStorage}/user_page_activites?relations=${relationsParam}`,
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        },
    );
    if (isPending) return <AdminPageLoader />;
    if (error) return <div>Error: {error.message}</div>;
    if (data && !data.success) return <AdminInternalError />;


    const prepareCSVData = (
        data: UserLandingActivty[],
    ): Array<{
        id: number;
        user_id: number;
        email: string;
        page_name: string;
        created_at: string;
    }> => {
        return data.map((item) => ({
            id: item.id,
            user_id: item.user_id,
            email: item.user ? item.user.email : 'N/A',
            page_name: item.page_name,
            created_at: item.created_at,
        }));
    };

    return (
        <AdminWrapper>
            <AdminPageHeader
                title="User Landing Activities"
                locale={locale}
                setLocale={setLocale}
                showLocaleButtonGroup={false}
                enableBulkDelete={false}
            >
                <Box
                    className="optionalHeaderData"
                    sx={{ display: 'flex', justifyContent: 'end', alignItems: 'end', width: '27%' }}
                >
                    <Button
                        type="button"
                        sx={{ color: '#fff', lineHeight: '26px' }}
                        variant="contained"
                        size="small"
                        color="success"
                        className="download-csv-button"
                        title="Download CSV"
                    >
                        <CSVLink
                            data={data?.data ? prepareCSVData(data.data) : []}
                            headers={headers}
                            filename="false_login_data.csv"
                        >
                            <CloudDownloadIcon sx={{ fontSize: '18px' }} /> CSV
                        </CSVLink>
                    </Button>
                </Box>
            </AdminPageHeader>
            <AdminDataGrid<UserLandingActivtyResponse> data={data} columns={columns} setSelectedIds={setSelectedIds} />{' '}
        </AdminWrapper>
    );
}

export default AllPagesLandingActivity
